import { render } from "./ProductFileUploadComponent.vue?vue&type=template&id=72ecd2a1"
import script from "./ProductFileUploadComponent.vue?vue&type=script&lang=js"
export * from "./ProductFileUploadComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/products/ProductFileUploadComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72ecd2a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72ecd2a1', __exports__)) {
    api.reload('72ecd2a1', __exports__)
  }
  
  module.hot.accept("./ProductFileUploadComponent.vue?vue&type=template&id=72ecd2a1", () => {
    api.rerender('72ecd2a1', render)
  })

}


export default __exports__